import React from 'react';
import Dashboard from './Dashboard';
import './App.css'; // Puoi rimuovere App.css se non lo usi più o lo personalizzi

function App() {
  // Puoi passare un ID stanza specifico qui, ad esempio per la stanza 2:
  // <Dashboard roomId="2" />
  return (
    <div className="App">
      <Dashboard roomId="1" /> {/* Visualizza la dashboard per la stanza con ID "1" */}
    </div>
  );
}

export default App;